import { createContext } from "react";

const AccountContext = createContext(null);

export default AccountContext;
